import React from 'react'
import { strings } from '../../../localization/strings'
import ConfigPanel from './configPanel'
import TextField from '@material-ui/core/TextField'

const Component = ({ config, handleEdit }) => {

    const handleChangeSecurityCodeTitle = (text) => {
        handleEdit({
            wasEdited: true,
            config: { ...config, lockerSecurityCodeTitleValue: text },
        })
    }

    return (
        <ConfigPanel
            title={strings.configLockerTitle}
            items={[
                {
                    label: strings.configLockerSecurityCodeTitle,
                    control: (
                        <TextField
                            value={config.lockerSecurityCodeTitleValue || ''}
                            onChange={(x) =>
                                handleChangeSecurityCodeTitle(x.target.value)
                            }
                            InputLabelProps={{ shrink: true }}
                            inputProps={{
                                maxLength:
                                    config.defaultLockerSecurityCodeTitleMaxLength ||
                                    34,
                            }}
                        />
                    ),
                },
            ]}
        />
    )
}

export default Component
